<template>
  <div v-if="loading">...</div>
  <div v-else-if="inspection"><Meeting :inspection="inspection" /></div>
  <div
    v-else
    class="no-data-card text-center mt-5 mb-4"
    lg="3"
  >
    {{ $t("messages.information.no_data") }}
  </div>
</template>

<script>
import { Meeting } from "@/components"
import { InspectionService } from "@/services"

export default {
  name: "InspectionMeeting",
  components: { Meeting },
  data() {
    return {
      inspection: undefined,
      loading: false
    }
  },
  beforeRouteLeave(from, to, next) {
    this.$store.commit("meeting/leave")
    next()
  },
  created() {
    // If not signedIn User and uuid is present redirect to InspectionMeetingUnauthenticated page
    let inspectionUuid = this.$route.params.uuid

    if (!this.$store.getters["app/isSignedIn"] && inspectionUuid) {
      if (this.$route.name !== "InspectionMeetingUnauthenticated")
        this.$router.push({
          name: "InspectionMeetingUnauthenticated",
          params: { uuid: inspectionUuid }
        })
    }

    this.getInspection(inspectionUuid)
  },
  methods: {
    getInspection() {
      let inspectionId = this.$route.params.id
      let inspectionUuid = this.$route.params.uuid

      // Check if either inspection id or uuid exists
      if (!inspectionId && !inspectionUuid) {
        return this.$store.commit("app/message", {
          msg: this.$t("messages.warning.valid_inspection"),
          color: "error"
        })
      }

      this.loading = true
      InspectionService.get(this, null, inspectionId, inspectionUuid)
        .then(response => {
          this.inspection = response
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
